import { render } from "./HeaderGlobal.vue?vue&type=template&id=1f868501&scoped=true"
import script from "./HeaderGlobal.vue?vue&type=script&lang=js"
export * from "./HeaderGlobal.vue?vue&type=script&lang=js"

import "./HeaderGlobal.vue?vue&type=style&index=0&id=1f868501&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f868501"]])

export default __exports__